import { type ReactElement } from 'react';
import { useRouteError } from 'react-router';

import Page404 from './Page404';
import SomethingWentWrong from './SomethingWentWrong';

import Redirect from '@/components/Redirect';

interface ErrorMessageType {
  message?: string;
  status: number;
}

const FallBackError = (): ReactElement | null => {
  const error = useRouteError() as ErrorMessageType | undefined | null;

  if (error?.message === 'ERR_NOT_FOUND') return <Page404 />;

  let parsedError: ErrorMessageType | null = null;

  if (error?.message) {
    try {
      parsedError = JSON.parse(error.message) as ErrorMessageType;
    } catch {
      parsedError = null;
    }
  }

  const status = error?.status ?? parsedError?.status;

  if (status === 401) {
    return (
      <Redirect
        to='/'
        replace={false}
      />
    );
  }

  return <SomethingWentWrong />;
};

export default FallBackError;
